const encodeHtml = (str) => {
    var map =
    {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        '"': '&#34;',
        '#': '%23'
    };
    return str.toString().replace(/&|>|<|"|'|#/g, function(m) {return map[m];});
}

export default encodeHtml